import React from "react";
import { connect } from "react-redux";
import { buttonVariants } from "../../ui/button";
import { cn } from "../../lib/utils";
import DownloadWidget from "../Common/DownloadWidget";
import {
  formatMoney,
  getBrowserDate,
  getDateTimeFormate,
  divideAmountBy100,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import { getEventDetails } from "./paymentHistoryTableSlice";
import Table from "../Common/table/Table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { COMMON_CONSTANTS, KYC_CONSTANTS, PAYMENT_CONSTANTS } from "../../sharedfiles/Constants";
import NoDataFound from "../Common/table/NoDataFound";
import { COMMON_MSGS, Payments, paymentHistoryInfo } from "../../sharedfiles/tooltipMsgs";
import Tooltips from "../Common/Tooltip";
import { viewLogInfo } from "../Common/data/Payments/PaymentsearchData";
import KycCommentBox from "../KycUsers/KycCommentBox";
import { cancelWithdrawal, getPaymentSearchtableList } from "../PaymentSearch/paymentSearchSlice";
import { ArrowUp, ArrowDown } from "lucide-react";
import { Table as ShadcnTable, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";
import TableToolbar from "../Common/table/TableToolbar";

const PaymentHistoryTableBody = ({ sortedData, tdsExist, ascending, onToggleSort, onCallEventDetails, onCancel }) => {
  const headerConfigs = [
    { label: PAYMENT_CONSTANTS.th_transactionId, tooltip: paymentHistoryInfo.txId },
    { label: COMMON_CONSTANTS.createdOn, tooltip: COMMON_MSGS.createdDate, sortable: true },
    { label: COMMON_CONSTANTS.updatedOn, tooltip: COMMON_MSGS.updatedDate, sortable: true },
    { label: COMMON_CONSTANTS.createdBy, tooltip: COMMON_MSGS.createdBy },
    { label: COMMON_CONSTANTS.updatedBy, tooltip: COMMON_MSGS.updatedBy },
    { label: COMMON_CONSTANTS.th_amount, tooltip: COMMON_MSGS.Amount, align: "text-right" },
    { label: KYC_CONSTANTS.header_status, tooltip: Payments.Status },
    ...(tdsExist ? [
      { label: PAYMENT_CONSTANTS.tds_amount, tooltip: paymentHistoryInfo.tdsAmount, align: "text-right" },
      { label: PAYMENT_CONSTANTS.tds_percentage, tooltip: paymentHistoryInfo.tdspercent, align: "text-right" },
    ] : []),
    { label: PAYMENT_CONSTANTS.th_method, tooltip: paymentHistoryInfo.method },
    { label: PAYMENT_CONSTANTS.th_paymentType, tooltip: paymentHistoryInfo.paymentType },
    { label: PAYMENT_CONSTANTS.th_paymentMethod, tooltip: paymentHistoryInfo.method },
    { label: PAYMENT_CONSTANTS.th_paymentDesc, tooltip: paymentHistoryInfo.paymentDesc },
    { label: PAYMENT_CONSTANTS.th_bankName, tooltip: paymentHistoryInfo.bankName },
    { label: PAYMENT_CONSTANTS.th_transactionRef, tooltip: paymentHistoryInfo.transRef },
    { label: KYC_CONSTANTS.header_action, tooltip: paymentHistoryInfo.action, align: "text-center" },
  ];
  const headers = headerConfigs.map((c) => c.label);

  const cellClassName = [
    undefined,
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm",
    "text-sm",
    "text-right",
    undefined,
    ...(tdsExist ? ["text-right text-sm", "text-right text-sm"] : []),
    "text-sm",
    "text-sm",
    "text-sm",
    "text-sm",
    "text-sm",
    "text-sm font-mono",
    "text-center whitespace-nowrap",
  ];

  const rowAccessors = [
    (item) => <span className='text-sm font-mono'>{item.id}</span>,
    (item) => getDateTimeFormate(item.createdDate),
    (item) => getDateTimeFormate(item.updatedDate),
    (item) => item.addedBy,
    (item) => item.updatedByUserName || '-',
    (item) => <span className='text-sm font-semibold'>{getConvertedAmountWithCurrency(item.amount ? item.amount : "0", item.currencyCode || item.currency, item.baseCurrencyRate)}</span>,
    (item) => (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${item.status === 'APPROVED' ? 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-400' :
          item.status === 'CONFIRMED' ? 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-400' :
            item.status === 'DECLINED' || item.status === 'CANCELLED' ? 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-400' :
              item.status === 'HOLD' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-400' :
                item.status === 'INIT' ? 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-400' :
                  item.status === 'VERIFIED' ? 'bg-teal-100 text-teal-800 dark:bg-teal-950 dark:text-teal-400' :
                    'bg-gray-100 text-gray-800 dark:bg-gray-950 dark:text-gray-400'
        }`}>
        {item.status}
      </span>
    ),
    ...(tdsExist ? [
      (item) => (item.tdsAmount ? getConvertedAmountWithCurrency(item.tdsAmount, item.currencyCode || item.currency, item.baseCurrencyRate) : "0"),
      (item) => item.tdsPercentage,
    ] : []),
    (item) => item.paymentMethodType,
    (item) => item.paymentType,
    (item) => item.modePaymentClient,
    (item) => divideAmountBy100(item.paymentDesc),
    (item) => item.bankName,
    (item) => item.transactionRef,
    (item) => (
      <div className='flex flex-col gap-2'>
        <span
          className={cn(buttonVariants({ variant: "outline", size: "sm" }), "cursor-pointer")}
          id='paymentDetails'
          onClick={() => onCallEventDetails(item.id)}
        >
          {COMMON_CONSTANTS.details}
        </span>
        <span
          className={cn(
            buttonVariants({ variant: "destructive", size: "sm" }),
            !(item.paymentType === "WITHDRAW" && (item.status === "INIT" || item.status === "APPROVED")) ? "opacity-50 pointer-events-none" : "cursor-pointer"
          )}
          id='paymentCancel'
          onClick={() => (item.paymentType === "WITHDRAW" && (item.status === "INIT" || item.status === "APPROVED")) && onCancel(item.id)}
        >
          {COMMON_CONSTANTS.cancel}
        </span>
      </div>
    ),
  ];

  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("paymentHistoryPaymentHistoryTable", headers);

  return (
    <div className="relative">
      <TableToolbar
        columns={allColumns}
        onToggle={toggleVisibility}
        onReorder={reorder}
        onReset={resetToDefault}
      />
      <ShadcnTable scrollKey="paymentHistoryPaymentHistoryTable">
        <TableHeader>
          <TableRow>
            {visibleIndices.map((origIdx) => {
              const c = headerConfigs[origIdx];
              return c.sortable ? (
                <TableHead
                  key={origIdx}
                  onClick={onToggleSort}
                  className='whitespace-nowrap cursor-pointer select-none hover:bg-muted/50 transition-colors'
                >
                  <div className='flex items-center gap-2'>
                    <span>{c.label}</span>
                    <Tooltips info={c.tooltip} />
                    {ascending ? <ArrowDown size={14} className='text-muted-foreground' /> : <ArrowUp size={14} className='text-muted-foreground' />}
                  </div>
                </TableHead>
              ) : (
                <TableHead key={origIdx} className={cn(c.align, "whitespace-nowrap")}>
                  <div className={cn("flex items-center gap-2", c.align === "text-right" ? "justify-end" : c.align === "text-center" ? "justify-center" : "")}>
                    <span>{c.label}</span>
                    <Tooltips info={c.tooltip} />
                  </div>
                </TableHead>
              );
            })}
          </TableRow>
        </TableHeader>

        <TableBody>
          {sortedData && Array.isArray(sortedData) && sortedData.length > 0 ? (
            sortedData.map((item, index) => (
              <TableRow key={item.id}>
                {visibleIndices.map((origIdx) => (
                  <TableCell key={origIdx} className={cellClassName[origIdx]}>
                    {rowAccessors[origIdx](item)}
                  </TableCell>
                ))}
              </TableRow>
            ))
          ) : (
            <NoDataFound colspan={visibleIndices.length} />
          )}
        </TableBody>
      </ShadcnTable>
    </div>
  );
};

class PaymentHistoryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // recordDetails: {},
      asceending: true,
      headers: [
        "Transaction ID",
        "Payment Description",
        "Event Type",
        "Reference",
        "Created",
        "Payment Methods",
        "Payment Type",
        "Request/Response"
      ],
      dialogData: [],
      openDetails: false,
      declineBox: false,
      txnId: ''
    };
    this.dateSorting = this.dateSorting.bind(this);
    this.callEventDetails = this.callEventDetails.bind(this);
  }

  dateSorting() {
    const getchedData = [...this.props.data];
    const sortData = getchedData.sort((a, b) => {
      const c = new Date(a.transaction_date);
      const d = new Date(b.transaction_date);
      return c - d;
    });
    return this.state.asceending ? sortData : sortData.reverse();
  }
  onDialogClose = () => {
    // this.props.dispatch(setSnackbar(false));
    this.setState({ openDetails: false });
    if (
      this.props.playerDetails !== null &&
      this.props.playerDetails !== undefined &&
      Object.keys(this.props.playerDetails).length > 0
    ) {
      this.setState({ dialogData: [] });
    }
  };
  callEventDetails = (id) => {
    if (id !== 0) {
      //  this.props.dispatch(setSnackbar(true));
      this.props.dispatch(getEventDetails(id));
      this.setState({ openDetails: true });
    }
  };

  updateDialogData() {
    const headers = this.state.headers;
    const data =
      this.props.playerDetails !== null &&
        this.props.playerDetails !== undefined &&
        this.props.playerDetails !== "" &&
        Object.keys(this.props.playerDetails).length > 0 &&
        this.props.playerDetails.length > 0
        ? this.props.playerDetails.map((item, ind) => [
          item.transaction_id,
          item.description,
          item.eventType,
          item.reference,
          getBrowserDate(item.createdAt),
          item.paymentMethod,
          item.paymentMethodType,
          item.data && typeof item.data === "object" ? JSON.stringify(item.data) : (item.data || "-")
        ])
        : [];
    const tableData = data.length > 0 ? [headers, viewLogInfo, ...data] : [headers, viewLogInfo, []];
    this.setState({ dialogData: tableData });
  }

  componentDidUpdate(prevProps) {
    if (this.props.playerDetails !== prevProps.playerDetails) {
      this.updateDialogData();
    }
  }

  onCancel(id) {
    this.setState({ declineBox: true })
    this.setState({ txnId: id })
  }
  onCloseCancelPopup() {
    this.setState({ declineBox: false })
  }

  handleReject(msg) {
    const data = {
      comments: msg
    }
    this.props.dispatch(cancelWithdrawal(this.state.txnId, data))
    this.props.dispatch(getPaymentSearchtableList(0, 25, { userId: localStorage.getItem("userId") }))
  }


  render() {
    return (
      <>
        {this.state.openDetails && (
          <Dialog open={this.state.openDetails} onOpenChange={(open) => !open && this.onDialogClose()}>
            <DialogContent className="sm:max-w-[900px] max-h-[80vh] flex flex-col">
              <DialogHeader className="flex flex-row items-center justify-between space-y-0 pr-14">
                <DialogTitle>Event Detail</DialogTitle>
                {this.props.enableDownload && <DownloadWidget tableData={this.state.dialogData} fileName={this.props.fileName || "payment-event-details"} pdfTitle={this.props.pdfTitle || "Payment Event Details"} />}
              </DialogHeader>
              <div className="overflow-x-auto overflow-y-auto flex-1 min-h-0">
                {this.state.dialogData && this.state.dialogData.length > 0 ? (
                  <Table tableData={this.state.dialogData} hLen={4} vLen={2} withCard={true} />
                ) : (
                  <div className="flex flex-col items-center justify-center py-12 text-center">
                    <p className="text-sm text-muted-foreground">No data found</p>
                  </div>
                )}
              </div>
            </DialogContent>
          </Dialog>
        )}
        <Dialog open={this.state.declineBox} onOpenChange={(open) => !open && this.onCloseCancelPopup()}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Action Needed</DialogTitle>
            </DialogHeader>
            <KycCommentBox
              transactionId={this.state.txnId}
              finish={(msg) => this.handleReject(msg)}
              close={() => this.onCloseCancelPopup()}
              cancelBtn
            />
          </DialogContent>
        </Dialog>
        <PaymentHistoryTableBody
          sortedData={this.props.data && Array.isArray(this.props.data) && this.props.data.length > 0 ? this.dateSorting() : []}
          tdsExist={this.props.tdsExist}
          ascending={this.state.asceending}
          onToggleSort={() => this.setState({ asceending: !this.state.asceending })}
          onCallEventDetails={(id) => this.callEventDetails(id)}
          onCancel={(id) => this.onCancel(id)}
        />
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    paymentData: state.paymentHistorySlice.paymentData,
    paginationFirstValue: state.paymentHistorySlice.paginationFirstValue,
    paginationSecondValue: state.paymentHistorySlice.paginationSecondValue,
    manauldata: state.paymentHistorySlice.manauldata,
    playerDetails: state.paymentHistorySlice.playerDetails,
  };
}
export default connect(mapStateToProps)(PaymentHistoryTable);